import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { PositionListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialPositionList } from '../../logics/positions/createInitialPositionList';

/**
 * 仕事内容に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const usePositions = (args: HooksArgument) => {
  const [positionList, setPositionList] = useState<PositionListType[]>(
    createInitialPositionList(args)
  );

  const selectedPositionList = useMemo(() => {
    return positionList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [positionList]);

  // チェック状態更新処理
  const updateIsCheckedPositionList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = positionList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setPositionList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [positionList]
  );

  // 求人件数更新処理
  const updatePositionListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setPositionList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    positionList,
    selectedPositionList,
    updateIsCheckedPositionList,
    updatePositionListJobCount,
  };
};
